import React from 'react';
import { Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';

const BuildingsPreview = ({ buildings }) => {
	const attachedBuildings = buildings.slice(0, 5);

	return (
		<div className='dashboard-panel dashboard-panel--full-height'>
			<div className='dashboard-panel__header'>
				<div>
					<h3 className='dashboard-panel__title'>Attached Buildings</h3>
					<p className='dashboard-panel__subtitle'>
						Buildings connected to your business
					</p>
				</div>

				<Link to='/building-search-page' className='dashboard-panel__link'>
					Manage
				</Link>
			</div>

			{attachedBuildings.length > 0 ? (
				<div className='dashboard-list'>
					{attachedBuildings.map((building) => (
						<div className='dashboard-list-item' key={building._id}>
							<div className='dashboard-list-item__icon dashboard-list-item__icon--building'>
								<Building2 size={18} />
							</div>

							<div className='dashboard-list-item__body'>
								<h4>{building.address}</h4>
								<p>
									{building.isActive ? 'Active building' : 'Inactive building'}
								</p>
							</div>
						</div>
					))}
				</div>
			) : (
				<div className='dashboard-empty'>
					No buildings attached yet. Start connecting with nearby apartments.
				</div>
			)}
		</div>
	);
};

export default BuildingsPreview;
